import React, { Component } from 'react';
import { Checkbox } from '@checkmarx/cx-ui';
import Checkboxes from './checkboxes';
import styles from './style.scss';
import { inject } from 'mobx-react';

@inject('rolesStore')
export default class permissionsCategory extends Component {

    toggleAllPermissionsCategory = (e) => {

        this.props.category.data.forEach(permission => {
            
            if(e.target.checked)
            {
                this.props.rolesStore.setPermissionId(permission.id)
                
            }
            else{
                this.props.rolesStore.removePermissionId(permission.id)
                
            }
        });
    }

    isAllCategoryPermissionSelected()
    {
        
        for(var i = 0; i < this.props.category.data.length; i++)
        {
            let permission = this.props.category.data[i];
            if(!this.props.rolesStore.permissionIds.includes(permission.id))
            {
                return false;
            }
        }

        return true;
    }

    render() {
        
        return (
            <div>
                <div className={styles.permissionsGroupCategoryName}>
                    <Checkbox
                        onChange={this.toggleAllPermissionsCategory}
                        text={this.props.category.name}
                        textClassName={styles.permissionCategoryCheckbox}
                        checked={this.isAllCategoryPermissionSelected()}
                    />
                </div>
                <div className={styles.permissionsWrapper}>
                    <Checkboxes
                        data={this.props.category.data}
                    />
                </div>
            </div>
        );
    }
}